import { render, staticRenderFns } from "./SavvyFlow.vue?vue&type=template&id=08e63e9c&scoped=true&"
import script from "./SavvyFlow.vue?vue&type=script&lang=ts&"
export * from "./SavvyFlow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e63e9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08e63e9c', component.options)
    } else {
      api.reload('08e63e9c', component.options)
    }
    module.hot.accept("./SavvyFlow.vue?vue&type=template&id=08e63e9c&scoped=true&", function () {
      api.rerender('08e63e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/util/Savvy/SavvyFlow.vue"
export default component.exports